module.exports = __webpack_public_path__ + "img/rewardWxBg.71092e50.png";